import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#009ef7', '#10b981', '#f59e0b', '#6366f1', '#ec4899', '#14b8a6', '#f97316', '#84cc16'];

const SourcePieChart = ({ data = [] }) => {
  const safeData = Array.isArray(data) ? data.filter((item) => Number(item?.value) > 0) : [];

  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4 h-[360px]">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Leads By Source</h3>
      </div>
      {safeData.length === 0 ? (
        <div className="h-[85%] flex items-center justify-center text-sm text-gray-400">No source data available</div>
      ) : (
        <ResponsiveContainer width="100%" height="88%">
          <PieChart>
            <Pie
              data={safeData}
              dataKey="value"
              nameKey="label"
              innerRadius={55}
              outerRadius={95}
              paddingAngle={2}
              animationDuration={700}
            >
              {safeData.map((entry, index) => (
                <Cell key={`${entry?.label || 'source'}-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend verticalAlign="bottom" height={30} wrapperStyle={{ fontSize: '12px' }} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SourcePieChart;
